import {Input} from "@pg-design/inputs-v2-module";
import {Text} from "@pg-design/text-module";

import type {IPromptProps} from "../types/IPromptProps";

import * as styles from "./PromptInput.module.css";

type IPromptInputProps = IPromptProps["input"] & {
    onChange: (value: string | number) => void;
};

export const PromptInput = (props: IPromptInputProps) => {
    return (
        <div className={styles.promptInput}>
            {props.prefix && <Text variant="body_copy_2">{props.prefix}</Text>}

            <Input type={props.type} value={props.value ?? ""} onChange={props.onChange} className={styles.input} />

            {props.suffix && <Text variant="body_copy_2">{props.suffix}</Text>}
        </div>
    );
};
import {Input} from "@pg-design/inputs-v2-module";
import {Text} from "@pg-design/text-module";

import type {IPromptProps} from "../types/IPromptProps";

import * as styles from "./PromptInput.module.css";

type IPromptInputProps = IPromptProps["input"] & {
    onChange: (value: string | number) => void;
};

export const PromptInput = (props: IPromptInputProps) => {
    return (
        <div className={styles.promptInput}>
            {props.prefix && <Text variant="body_copy_2">{props.prefix}</Text>}

            <Input type={props.type} value={props.value ?? ""} onChange={props.onChange} className={styles.input} />

            {props.suffix && <Text variant="body_copy_2">{props.suffix}</Text>}
        </div>
    );
};
